module.exports = new __parcel__URL__("empty-help-links.ba11e4e4.svg").toString();